// extracted by mini-css-extract-plugin
export default {"questionsListWrapper":"JtLwo","loaderWrapper":"ljY0h","loader":"H45r1","question":"TgGHV","addQuestionWrapper":"LJVS2","addQuestionButton":"WgmnU"};